import { SUPPORTED_LOCALES_OBJ } from '@zep-us/i18n';
import { type GetStaticPropsContext } from 'next';
import { getDefaultStaticProps } from '@/utils';
import { Landing } from '../../views/Landing';
export default function LandingPage() {
  return <Landing data-sentry-element="Landing" data-sentry-component="LandingPage" data-sentry-source-file="index.page.tsx" />;
}
export const getStaticProps = async ({
  locale = SUPPORTED_LOCALES_OBJ.en
}: GetStaticPropsContext) => {
  return getDefaultStaticProps({
    locale,
    namespaces: ['landing', 'board']
  });
};